module.exports = __webpack_public_path__ + "img/gasbot-icon.98d8ac67.svg";